var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 21.5,
    r: 21.5,
    fill: "#E6E6E6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(13, 11) scale(0.035)",
    fill: "#033476"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M483.6,455.1H28.4C12.7,455.1,0,442.4,0,426.7s12.7-28.4,28.4-28.4h455.1c15.7,0,28.4,12.7,28.4,28.4s-12.7,28.4-28.4,28.4h0ZM202.5,284.4H22.5C10.1,284.4,0,271.7,0,256s10.1-28.4,22.5-28.4h180c12.4,0,22.5,12.7,22.5,28.4s-10.1,28.4-22.5,28.4ZM483.6,113.8H28.4C12.7,113.8,0,101,0,85.3s12.7-28.4,28.4-28.4h455.1c15.7,0,28.4,12.7,28.4,28.4s-12.7,28.4-28.4,28.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.7,278.3h67c12.3-.2,22.2-10.4,22-22.7-.2-12-9.9-21.7-22-22h-67s0-67.1,0-67.1c-.2-12.3-10.4-22.2-22.7-22-12,.2-21.7,9.9-22,22v67s-67,0-67,0c-12.3-.2-22.5,9.6-22.7,22-.2,12.3,9.6,22.5,22,22.7.3,0,.5,0,.8,0h67s0,67.1,0,67.1c.2,12.3,10.4,22.2,22.7,22,12-.2,21.7-9.9,22-22v-67Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenus);
export default __webpack_public_path__ + "static/media/menus+.62837f729967ac6c94bcce252da71e06.svg";
export { ForwardRef as ReactComponent };